var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExtra2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.408203,
    width: 58,
    height: 58,
    rx: 10,
    fill: "#152833"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0001 27.5889H35.5892V27.5882C35.5892 25.1776 34.3036 23.0885 32.2141 21.9636L37.9999 12C43.3037 15.0537 47.0001 20.8394 47.0001 27.5889ZM25.624 21.9646C23.6957 23.0895 22.41 25.1786 22.41 27.5892L11 27.5899C11 21.0012 14.5354 15.215 19.9993 12.001L25.624 21.9646ZM28.9993 34.1777C27.7136 34.1777 26.5887 33.8562 25.6245 33.2135L19.9995 43.3381C22.7316 44.9453 25.7849 45.7487 28.9998 45.7487C32.2138 45.7487 35.4282 44.9453 38 43.3381L32.2142 33.3745C31.2501 33.8568 30.1251 34.1783 29.0002 34.1783L28.9993 34.1777ZM28.9995 30.4818C30.5973 30.4818 31.8924 29.1867 31.8924 27.5889C31.8924 25.9914 30.5973 24.696 28.9995 24.696C27.4017 24.696 26.1066 25.9914 26.1066 27.5889C26.1066 29.1867 27.4017 30.4818 28.9995 30.4818Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.898 50L48.1 38.336L48.712 39.38H41.566L42.682 38.246V41.522H40.504V37.4H50.296V38.966L45.4 50H42.898Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtra2);
export default __webpack_public_path__ + "static/media/extra2.43607bacc280e9010c7d84e04e7370bb.svg";
export { ForwardRef as ReactComponent };